import SEOMeta from '@/components/base/SEOMeta';
import HeroBanner from './components/HeroBanner';
import FeaturedArticles from './components/FeaturedArticles';
import TrendingTopics from './components/TrendingTopics';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '吃瓜网',
  url: 'https://chigua.com',
  logo: 'https://chigua.com/logo.png',
  description: '最新热门八卦娱乐资讯平台，海量吃瓜内容实时更新，独家爆料不断，让您第一时间掌握最劲爆的娱乐资讯。',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CN',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    streetAddress: '星光大道88号',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    email: 'contact@chigua.com',
  },
  sameAs: [
    'https://weibo.com/chigua',
    'https://weixin.qq.com/chigua',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '吃瓜网',
  url: 'https://chigua.com',
  description: '最新热门八卦娱乐资讯平台，海量吃瓜内容实时更新，独家爆料不断。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://chigua.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '吃瓜网 - 最新热门八卦娱乐资讯平台',
  description: '吃瓜网是您获取最新娱乐八卦、明星动态、热门事件的首选平台。海量吃瓜内容实时更新，独家爆料不断。',
  url: 'https://chigua.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '吃瓜网',
    url: 'https://chigua.com',
  },
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="最新热门八卦娱乐资讯平台"
        description="吃瓜网是您获取最新娱乐八卦、明星动态、热门事件的首选平台。海量吃瓜内容实时更新，独家爆料不断，让您第一时间掌握最劲爆的娱乐资讯，畅快吃瓜不停歇。"
        keywords="吃瓜网,吃瓜爆料,娱乐八卦资讯,明星八卦最新消息,热门事件追踪,网红爆料平台,娱乐圈内幕"
        canonicalUrl="https://chigua.com"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <HeroBanner />
      <FeaturedArticles />
      <TrendingTopics />
      <CategorySection />
      <LatestArticles />
    </>
  );
}